angular.module('llax')
    .controller('showYoutubeController', ['$rootScope', '$scope', '$document', '$modalInstance', '$http', '$translate', '$filter', '$parse', 'growl', 'FileUploader', 'videoId',
        function($rootScope, $scope,$document, $modalInstance, $http, $translate, $filter, $parse, growl, FileUploader, videoId) {
            $scope.youtubeUrl = "https://www.youtube.com/embed/" + videoId + "?&autoplay=1";
            $scope.cancel = function() {
                $modalInstance.dismiss('cancel');
                $rootScope.additionalModalOpen = false;
                $document.off('keydown', keyPressed);
            };

            function keyPressed($event) {
                if ($event.keyCode == 27) {
                    $event.preventDefault();
                    $scope.cancel();
                }
            }
            $document.on('keydown', keyPressed);

        }]);
